/**
 * This is a generated file. Do not edit directly
 */

export const breakpointWidth100 = "320px";
export const breakpointWidth200 = "375px";
export const breakpointWidth250 = "480px";
export const breakpointWidth275 = "600px";
export const breakpointWidth300 = "834px";
export const breakpointWidth350 = "992px";
export const breakpointWidth400 = "1152px";
export const breakpointWidth500 = "1440px";
export const breakpointWidthMobile = "375px";
export const breakpointWidthTablet = "834px";
export const breakpointWidthDesktop = "1152px";
export const breakpointHeight100 = "568px";
export const breakpointHeight200 = "667px";
export const breakpointHeight300 = "1194px";
export const breakpointHeight400 = "700px";
export const breakpointHeight500 = "1024px";
export const breakpointHeightMobile = "375px";
export const breakpointHeightTablet = "834px";
export const breakpointHeightDesktop = "1152px";